<div class="input-cell">
  <cc-time-picker
    [model]="cellData._time"
    [isInTable]="true"
    (changeValue)="handleOnChange($event)"
    name="{{ 'column-' + cellData.id }}"
  >
  </cc-time-picker>
</div>
